import React, { createContext } from "react";
import { getDefaultThemeId, getThemeStyles } from "../../utils/theme.utils";

const stylesId = "default-styles";

function getStylesNode() {
  let node = document.getElementById(stylesId);

  if (!node) {
    node = document.createElement("style");
    node.setAttribute("id", stylesId);
  }

  return node;
}

export type ThemeContextType = {
  theme: string; // TODO: change to enum
};

export const ThemeContext = createContext({});

export const ThemeProvider = ({ children }: { children: any }) => {
  const [theme] = React.useState(() => getDefaultThemeId());

  const { mainStyles } = getThemeStyles(theme);

  React.useEffect(() => {
    let styleNode = getStylesNode();
    if (mainStyles) {
      const styleInCss = Object.entries(mainStyles)
        .map(([key, value]) => `${key}:${value}`)
        .join(";\n");

      styleNode.innerHTML = `:root {\n${styleInCss}\n}`;

      const headNode = document.querySelector("head")!;
      headNode.append(styleNode);
    }
  }, [mainStyles]);

  const context = React.useMemo(() => ({ theme }), [theme]);

  return (
    <ThemeContext.Provider value={context}>{children}</ThemeContext.Provider>
  );
};
export const useThemeStyles = () => {
  const { theme } = React.useContext(ThemeContext) as ThemeContextType;
  return { ...getThemeStyles(theme) };
};
